import styled from '@emotion/styled';

// Internal modules
import { StyledText } from '@/components/Common';

export const InlineContentContainer = styled.span`
  font-weight: 600;
`;

export const CupOtpStyledText = styled(StyledText)`
  margin-bottom: 8px;
`;
